<template>
  <article id="services" class="layout-section">
    <section class="layout-section__hgroup -flex -button -dropdown">
      <div class="layout-section__hgroup-container">
        <div class="layout-section__hgroup">
          <span v-appear:right class="layout-section__toptitle">{{ $t('home.services.title') }}</span>
          <h2 v-appear:right="{ delay: 100 }" class="layout-section__title -no-bottom">
            {{ $t('common.navigation.services') }}
          </h2>
        </div>

        <p v-appear:right="{ delay: 125 }">{{ $t('home.services.content') }}</p>
      </div>

      <a v-appear:left="{ delay: 175 }" href="https://iefa-plus.com/" target="_blank" class="button">
        {{ $t('common.cta.learnMore') }}
      </a>
    </section>

    <section class="layout-dropdown">
      <template v-for="{ key, title, content } in entriesWithKeys">
        <article :key="`${key}-header`" v-appear class="layout-dropdown__item">
          <header class="layout-dropdown__title" @click="toggleSection(key)">
            {{ title }}
            <figure class="layout-dropdown__icon" :class="{ '-active': key === expandedSection }">+</figure>
          </header>

          <DropDown :key="key" :is-open="key === expandedSection" content-class="layout-dropdown__content">
            <div v-html="content" />
          </DropDown>
        </article>
      </template>
    </section>

    <a v-appear:left="{ delay: 175 }" href="https://iefa-plus.com/" target="_blank" class="button -mobile">
      {{ $t('common.cta.learnMore') }}
    </a>
  </article>
</template>

<script>
export default {
  name: 'HomeService',
  data() {
    return { expandedSection: null }
  },
  computed: {
    entriesWithKeys() {
      return this.$t('home.services.entries').map((entry, index) => ({ ...entry, key: index }))
    }
  },
  methods: {
    toggleSection(key) {
      this.expandedSection = key === this.expandedSection ? null : key
    }
  }
}
</script>
